import theBodyKeepsScore from './images/theBodyKeepsScore.jpg'
export const books = [
  {
    author: 'James Clear',
    title: 'Atomic Habits',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/81wgcld4wxL._AC_UL900_SR900,600_.jpg',
    id: 1,
  },
  {
    author: 'Collen Hoover',
    title: 'It Starts with Us: A Novel (It Ends with Us)',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/71PNGYHykrL._AC_UL600_SR600,400_.jpg',
    id: 2,
  },
  {
    author: 'Collen Hoover',
    title: 'It Ends with Us: A Novel (1)',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/81s0B6NYXML._AC_UL600_SR600,400_.jpg',
    id: 3,
  },
  {
    author: 'Bonnie Garmus',
    title: 'Lessons in Chemistry: A Novel',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/71f266wrP+L._AC_UL600_SR600,400_.jpg',
    id: 4,
  },
  {
    author: 'Jennie Casselman & Andres Chaparro',
    title: 'Eager 2 Cook, Healthy Recipes for Healthy Living: Beef & Poultry',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/612Ko7Ps0uL._AC_UL600_SR600,400_.jpg',
    id: 5,
  },
  {
    author: 'Taylor Jenkins Reid',
    title: 'The Seven Husbands of Evelyn Hugo: A Novel',
    imgSrc:
      'https://images-na.ssl-images-amazon.com/images/I/71ZvnK+4JiL._AC_UL300_SR300,200_.jpg',
    id: 6,
  },
  {
    author: 'Bessel van der Kolk M.D.',
    title:
      'The Body Keeps the Score: Brain, Mind, and Body in the Healing of Trauma',
    imgSrc: theBodyKeepsScore,
    id: 7,
  },
];
